var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSummaryBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2049,
    height: 2642,
    viewBox: "0 0 2049 2642",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.2676 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.957 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M288.648 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M393.338 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M498.027 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M602.719 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M707.408 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M812.098 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M916.789 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.48 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.17 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1230.86 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.55 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1440.24 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1544.93 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1649.62 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1754.31 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1859 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1963.69 0.12793V2641.37",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 43.749H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 141.896H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 240.043H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 338.19H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 436.337H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 534.484H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 632.631H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 730.778H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 828.925H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 927.072H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 1025.22H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 1123.37H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 1221.51H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 1319.66H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 1417.81H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 1515.95H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 1614.1H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 1712.25H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 1810.39H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 1908.54H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2006.69H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2104.83H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2202.98H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2301.13H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2399.28H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2497.42H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2595.57H2048.75",
    stroke: "#F8F8F6",
    strokeWidth: 4.36209
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryBg);
export default __webpack_public_path__ + "static/media/summaryBg.d47522a4bbcaf2b54a7a8299a0c6cbcc.svg";
export { ForwardRef as ReactComponent };